export default __webpack_public_path__ + "static/media/screenshot-plugin.f438ecd3.png";